/**
 * Cartão "Governadores" nas regiões do AppShell (§11.1 bloco 6, §4.6.2, §4.7, §4.8; FE §5.6): o `GovernorsPanel` na
 * aba Governadores com `features.governors` ligada. Fica fora do App.tsx, como o herói, o mapa, os painéis e os cartões.
 *
 * Onde aparece (a aba Governadores troca o herói e o gráfico do Presidente por ele):
 * - `left` (desktop e TV): sempre na aba, com ou sem foco; a coluna some abaixo de 1280 px lógicos com foco (§4.4).
 * - `card` (tablet, `land` e `flow`): só sem lugar em foco e sem perfil; com foco, o cartão do §8 (`PlaceSlot`). No
 *   `flow` com foco o painel não entra na pilha: a coluna "Governadores com foco" de §4.6.2 (dona da ordem) é mapa →
 *   linha do tempo → selo → `UfCard`; a frase "depois do mapa com foco" de §11.1 bloco 6 fala da posição do cartão.
 * Erros: a boundary da região (`left-column` ou `place-card`, §12.8) já envolve o slot.
 *
 * Chunk (B07, DE-C20): o painel fica no chunk `index`, como os cartões do §8 (placesSlot.tsx). Com o `import()` de
 * features/governors, o Rolldown 1.2.13 deixa de fundir o núcleo comum (Preact, sinais, estado, catálogo) no `index` e
 * o tira num chunk `hooks-*.js` fora do B01 (o mesmo caso do `theme/ink.ts` da Fase 5 e dos cartões da 7a); nenhuma
 * opção de `codeSplitting`/`chunkOptimization` evitou. No `index`, o painel custa ~3,3 KB br no B01 (76 → ~79 de 150)
 * e existe no mesmo quadro da troca de aba (sem região vazia esperando o chunk).
 */
import { GovernorsPanel } from '../features/governors/GovernorsPanel';
import { useConfig, useHasFocus, useRouteState } from '../state/hooks';

/** Região do AppShell em que o painel está montado. */
export type GovernorsRegion = 'left' | 'card';

/** O painel aparece nesta região, nesta rota? (o AppShell decide se a região existe no modo) */
export function governorsVisible(region: GovernorsRegion, office: string, governorsOn: boolean, hasFocus: boolean) {
  if (!governorsOn || office !== 'governor') return false;
  return region === 'left' || !hasFocus;
}

export function GovernorsSlot({ region }: { region: GovernorsRegion }) {
  const route = useRouteState();
  const cfg = useConfig();
  const hasFocus = useHasFocus();
  if (!governorsVisible(region, route.office, cfg.features.governors, hasFocus)) return null;
  return <GovernorsPanel />;
}
